export const knownQuerytringParams = {
  organizationId: "organizationId",
  dashboardId: "dashboardId",
  timeRange: "timeRange",
};

export function getQuerystringParams(urlSearchParams: URLSearchParams) {
  return Object.fromEntries(urlSearchParams.entries());
}
